import { forwardRef } from "react";
import { isElectron } from "../../lib/platform";

interface EmbeddedBrowserFrameProps {
  title: string;
  src: string;
  className?: string;
  partition?: string;
}

export const EmbeddedBrowserFrame = forwardRef<any, EmbeddedBrowserFrameProps>(
  function EmbeddedBrowserFrame(
    {
      title,
      src,
      className = "w-full h-full bg-[var(--fintheon-bg)]",
      partition = "persist:fintheon",
    },
    ref,
  ) {
    if (isElectron()) {
      return (
        <webview
          ref={ref}
          title={title}
          src={src}
          className={className}
          style={{ backgroundColor: "var(--fintheon-bg)", colorScheme: "dark" }}
          allowpopups
          partition={partition}
          webpreferences="nativeWindowOpen=yes"
        />
      );
    }

    return (
      <iframe
        ref={ref}
        title={title}
        src={src}
        className={className}
        style={{ backgroundColor: "var(--fintheon-bg)", colorScheme: "dark" }}
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals allow-top-navigation-by-user-activation"
      />
    );
  },
);
